import { Link } from 'react-router-dom';
import { AuthContext } from '../auth';
import React from 'react';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { url } from '../api';
import styled from 'styled-components';

export default function Header() {
  const authContext = React.useContext(AuthContext);
  const logout = useMutation({
    mutationFn: () => {
      return axios
        .post(
          url('/logout'),
          {},
          {
            withCredentials: true,
          },
        )
        .then((res) => res.data);
    },
    onSuccess: () => {
      window.location.reload();
    },
  });

  return (
    <HeaderContainer>
      <Link to="/queue" style={{ textDecoration: 'none' }}>
        Queue
      </Link>
      {authContext.auth && (
        <>
          <div>{authContext.user.email}</div>
          <div>
            <a href="#" onClick={() => logout.mutate()}>
              Logout
            </a>
          </div>
        </>
      )}
    </HeaderContainer>
  );
}

const HeaderContainer = styled.div`
  display: flex;
  height: 32px;
  padding: 10px 24px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  flex-direction: row;
  background: var(--white);
`;
